module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-cf-project-feedback-detail"
  }, [_c('div', {
    staticClass: "page"
  }, [(_vm.privateForm === '') ? _c('div') : (_vm.privateForm) ? _c('div', [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("反馈详情")]), _vm._v(" "), _c('p', {
    staticClass: "private_form"
  }, [_vm._v("该表单为“私密表单”，请联系表单创建人申请权限查看反馈详情")])]) : _c('div', [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("反馈详情 " + _vm._s(_vm.state.index) + "/" + _vm._s(_vm.state.count))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('div', [_vm._l((_vm.rows), function(row) {
    return [_c('lxm-form-row', {
      attrs: {
        "row": row
      }
    })]
  })], 2) : _vm._e()])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a890e4d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a890e4d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Form/FeedbackDetail.vue
// module id = 839
// module chunks = 0